import React from "react";

const Heading = () => {
  return (
    <section className="as_breadcrum_wrapper">
      <div className="container animate__animated animate__fadeInUp animate__repeat-1 animate__delay-1s ">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h1 className="as_heading as_heading_center">About us</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Heading;
